import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import 'vant/lib/index.css'
import 'lib-flexible'
import LocalFilterSelect from '@/components/LocalFilterSelect.vue';
import CaptchaInput from '@/components/CaptchaInput.vue';


import 'vant/lib/index.less'
import { 
  Toast,
  Button,
  Field,
  Picker,
  Popup,
  Row,
  Col,
  Checkbox,
  Search,
  Panel,
  DatetimePicker 
} from 'vant'
Vue.component('LocalFilterSelect', LocalFilterSelect);
Vue.component('CaptchaInput', CaptchaInput);

Vue.use(Button)
Vue.use(Field)
Vue.use(Picker)
Vue.use(Popup)
Vue.use(Row)
Vue.use(Col)
Vue.use(Checkbox)
Vue.use(Search)
Vue.use(Panel)
Vue.use(Toast)
Vue.use(DatetimePicker)
Vue.prototype.$toast = Toast;
Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
